import React from "react";
import { Row, Col, Typography } from "antd";
import UploadBtn from "./upload_btn";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { bailiffJobExtractingCountSelector } from "store/bailiff/bailiff/job/bailiff_job.selector";
import { useJobRefine } from "hook/bailiff/job/action/useJobRefine";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const BailiffUpload = () => {
  // -------------------------- VAR -----------------------------
  const { extracting } = useJobRefine();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row gutter={[20, 20]}>
        <Col xl={24} lg={24} md={24} xs={24}>
          <Typography.Text style={{ fontSize: 18 }} type="secondary">
            Tải lên file mới
          </Typography.Text>
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <UploadBtn />
        </Col>
      </Row>
    );
  };

  const renderExtracting = () => {
    if (!extracting) return null;
    return (
      <div className="mt-[24px] flex min-h-[40px] items-center gap-[8px] bg-white p-[8px] shadow">
        <InfoCircleOutlined className="text-[16px] text-blue-400" />
        <span className="italic text-gray-400">
          Có {extracting} file đang tiến hành khử nhiễu và phân tích...
        </span>
      </div>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Row style={{ minHeight: 200, padding: "20px 0px" }} justify="center">
      <Col xl={14} lg={14} md={24} xs={24}>
        {renderBody()}
      </Col>
      <Col xl={14} lg={14} md={24} xs={24}>
        {renderExtracting()}
      </Col>
    </Row>
  );
};
export default BailiffUpload;
